import { getXPartner, setXPartnerfromQueryString } from "@/app/utils/helper";

interface Headers {
    [key: string]: string;
}

const requestHeaders: Headers = {
    "X-partner": getXPartner(),
};

const requestOptions: RequestInit = {
    headers: requestHeaders,
};

export const getUEListData = async ({ isin }: { isin?: string } = {}) => {
    try {
        const url = isin 
            ? `${process.env.API_BASE_URL}/unlisted/equities/isins/${isin}` 
            : `${process.env.API_BASE_URL}/unlisted/equities/isins`;
        const response = await fetch(url,requestOptions);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err;
    }
};

export const getBondsListData = async () => {
    try {
        const response = await fetch(`${process.env.API_BONDS_URL}/orobonds/bonds/`,
            {
                headers: {
                    "flag": "jump-to-bidd",
                    "Content-Type": "application/json",
                    "X-partner" : getXPartner()
                },
                credentials: "include",
            }
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const result = await response.json();
        return result;
    } catch (err) {
        // console.error("Error fetching data:", err);
        return err
    }
};

export const getFaqsData = async () => {
    try {
        const response = await fetch(
            `${process.env.API_BASE_URL}/faqs/generic?productType=others`,requestOptions
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err
    }
};

export const getBannerData = async () => {
    try {
        setXPartnerfromQueryString();
        const response = await fetch(
            `${process.env.API_BASE_URL}/funds/getBannerData`,
            requestOptions,
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err
    }
}

export const getCalculatorData = async () => {
    try {
        const response = await fetch(`${process.env.API_BASE_URL}/seo/calculator/`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err
    }
}

export const getFdFaqsData = async (calcId: string) => {
    try {
        const response = await fetch(
            `${process.env.API_BASE_URL}/faqs/${calcId}?productType=calculator`,requestOptions
        );
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        return result;
    } catch (err) {
        console.error("Error fetching data:", err);
        return err
    }
};